/* */
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'redux/actions';
import { isEmpty } from 'lodash';

const { getCarrierList } = actions;

export default ({ groupId, country, isTriggered = true } = {}) => {
  const authReducer = useSelector((state) => state.authReducer);
  const listCarrier = useSelector((state) => state.othersReducer.listCarrier);
  const dispatch = useDispatch();

  useEffect(() => {
    const { sessionId, isLogin } = authReducer;
    if (isLogin && sessionId && isTriggered) {
      dispatch(getCarrierList({ groupId, country }));
    }
  }, [authReducer.isLogin, groupId, country, isTriggered]);

  return useMemo(() => {
    if (!authReducer.isLogin || isEmpty(listCarrier)) {
      return [];
    }

    return Object.values(listCarrier);
  }, [authReducer.isLogin, listCarrier]);
};
